module.exports = __webpack_public_path__ + "img/weplat.ff2d05de.png";